import printJS from "print-js";
import api from '../service/AxiosInstance';
import instance from "../service/AxiosInstance";

// const baseUrl = 'http://dd-elite:8085/api/';
// const baseUrl = 'http://10.113.243.174:8083/api/';
// const baseUrl = 'https://portail.ipmipres.com/office/api/';
const baseUrl = 'https://portail.ipm-africmanagement.com/office/api/';
// const baseUrl = 'https://portail.ipmpetitecote.com/office/api/';
// const baseUrl = 'https://portail.ipmics.com/office/api/';
// const baseUrl = 'https://portail.ipmsagam.com/office/api/';
// const baseUrl = 'https://portail.ipmubipharm.com/office/api/';
// const baseUrl = 'https://portail.ipmeiffage.com/office/api/';



export const printPDF = (url) => {

    printJS({
        printable: baseUrl + url,
        // printable: instance.baseUrl + url,
        type: 'pdf',
        onPdfOpen: true,
        fallbackPrintable: true
        // showModal: true,
        // modalMessage: 'Chargement en cours'
    });

};

